import DataTable from "../../components/dataTables/DataTable";
import {useArticle, useArticles, useMedia} from "../../hooks";
import {LeftSideMenu} from "../../components/leftSideMenu/LeftSideMenu";
import {useState} from "react";
import {buildColDefs} from "../../components/dataTables/buildColDefs";
import {Article} from "../../data-parsing/articles/Article";
import {CreationForm, CreationFormTemplate} from "../../components/form/CreationForm";
import {AddArticleFormTemplate} from "../../data-parsing/articles/FormTemplate";
import {ScrollableDragDropForm} from "../../components/form/DragDropForm";
import {TabbedContent} from "../../components/tabs/TabbedContent";
import {fileToDataURL} from "../../data-parsing/parseUtils";

export default function Articles() {
    const [query, setQuery] = useState(null);
    const {createMedia} = useMedia("food/articles/", "");
    const {articles, createArticle, deleteArticle} = useArticles(query);
    const {updateArticle} = useArticle();
    const colDefs = buildColDefs(Article);

    const afterSubmit = (newElement, parsedFormData) => {
        let index = 0;
        console.log("newElement", newElement?._id);
        while (parsedFormData[0][`file${index}`] && parsedFormData[0][`file${index}`].size) {
            fileToDataURL(newElement?._id, parsedFormData[0][`file${index}`], "", createMedia, false);
            console.log("newElement", newElement?._id);
         
            ++index;
        }
    }

    return <LeftSideMenu active="articles">
        <div id="wrapper">
            <div className="container">
                <div className="row">
                    <div className="col-xs-12">
                        <div className="card-box card-tabs m-t-20">
                            <h4 className="header-title m-t-0 m-b-30 pull-right">ARTÍCULOS</h4>
                            <TabbedContent removeContent={false} tabHeaders={[
                                <button data-toggle="tab" aria-expanded="true"><i
                                    className="fas fa-plus-circle"></i> NUEVO ARTÍCULO</button>,
                                <button data-toggle="tab" aria-expanded="false"
                                   onClick={() => setQuery(0)}>
                                    <i className="far fa-eye"></i> LISTAR ARTÍCULOS
                                </button>
                            ]}>
                                <div className="fade in">
                                    <div className="row">
                                        <CreationForm createFunction={createArticle} afterSubmit={afterSubmit}>
                                            <div className="col-md-5">
                                                <div className="form-group">
                                                    <label>Imagen</label>
                                                    <ScrollableDragDropForm fileTypes={["JPG", "PNG", "GIF"]}/>
                                                </div>
                                            </div>

                                            <CreationFormTemplate formTemplate={AddArticleFormTemplate}
                                                                  dataTemplate={Article}/>

                                            <div className="col-sm-12">
                                                <button className="btn btn-rounded btn-purple m-t-20"
                                                        style={{marginLeft: "12px"}}><i
                                                    className="far fa-save"></i> Guardar
                                                    artículo
                                                </button>
                                            </div>
                                        </CreationForm>
                                    </div>
                                </div>
                                <div className="fade in">
                                    <DataTable colDefs={colDefs} data={articles} dataId={"Articles"} resizable={true}
                                               allowHiddenColumns={true} scrollX={false}
                                               editElement={updateArticle} deleteElement={deleteArticle}
                                               className="table table-bordered panel-group" dataTemplate={Article}/>
                                </div>
                            </TabbedContent>
                        </div>
                    </div>

                </div>
            </div>

        </div>

    </LeftSideMenu>
}